import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgFrenchFlagBlackAndWhite = props => _jsxs("svg", _objectSpread(_objectSpread({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [_jsx("rect", {
    x: 0.25,
    y: 4.25,
    width: 23.5,
    height: 15.634,
    rx: 1.464,
    fill: "#fff",
    stroke: "#F8F8F8",
    strokeWidth: 0.5
  }), _jsx("mask", {
    id: "french-flag-black-and-white_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 24,
    height: 17,
    children: _jsx("rect", {
      x: 0.25,
      y: 4.25,
      width: 23.5,
      height: 15.634,
      rx: 1.464,
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 0.5
    })
  }), _jsxs("g", {
    mask: "url(#french-flag-black-and-white_svg__a)",
    children: [_jsx("path", {
      fill: "#7C7C7C",
      d: "M16 4h8v16.134h-8z"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 20.134h8V4H0v16.134Z",
      fill: "#393939"
    })]
  })]
}));
export default SvgFrenchFlagBlackAndWhite;